import { removeChildren } from "@rootreeweb/js-lib";

import { getTranslation } from "../helpers";
import type { ProductFormRequest } from "./form-data";
import { packageRequest } from "./form-data";

let contactForm: HTMLFormElement;
let formParent: HTMLElement;

type FormSubmitFunction = (e: ProductFormRequest) => Promise<unknown>;

let formSubmitFunction: FormSubmitFunction;

/**
 * Initializes the form submission.
 *
 * @throws Error If the form parent is not an HTMLElement.
 */
export function initializeForm(): void {
	contactForm = document.getElementById("rt-pspr-form") as HTMLFormElement;
	formParent = contactForm.parentElement as HTMLElement;
	if (!formParent) {
		throw new Error("Form parent is not an HTMLElement");
	}
	//deferredHeadlessSubmission(1255).then((e) => (formSubmitFunction = e));
	formSubmitFunction = async (e) => {
		const requestURL = `/wp-json/RTPseudoProducts/v1/info_request`;
		const { nonce } = rtpspr_PSPR_Product_ajax_obj.payload;
		if (e["Consent Text"]) {
			e["Consent Text"] =
				contactForm.querySelector('[for="consent-text"]')?.textContent || "";
			e["Consent Time"] = new Date().toISOString();
		}
		const response = await fetch(requestURL, {
			body: JSON.stringify({
				...e,
			}),
			headers: {
				"Content-Type": "application/json",
				"X-WP-Nonce": nonce,
			},
			method: "POST",
		});
		if (!response.ok) {
			const error = await response.json();
			if (error && typeof error === "object" && "data" in error) {
				throw new Error(`${error.data}`);
			}
		}
		const result = await response.json();
		if (result === -1) {
			throw new Error("Error submitting form, please refresh and try again");
		}
		return result;
	};
	contactForm?.addEventListener("submit", (e) => submitForm(e));
}

/**
 * Creates an error display div.
 *
 * @param error The error message.
 */
function createErrorDiv(error: string) {
	const errorDiv = document.createElement("div");
	errorDiv.textContent = error;
	removeChildren(formParent);
	formParent.append(errorDiv);
}

/** Creates a loading div. */
function createLoadingDiv() {
	const loadingDiv = document.createElement("div");
	loadingDiv.className = "rt-loader";
	loadingDiv.textContent = getTranslation("loading");
	removeChildren(formParent);
	formParent.append(loadingDiv);
	document.location.hash = "rt-pspr-product-details";
}

/** Creates a success div. */
function createSuccessDiv() {
	removeChildren(formParent);
	const successDiv = document.getElementById(
		"rt-pspr-success",
	) as HTMLDivElement;
	formParent.append(successDiv);
	successDiv.style.display = "block";
}

/**
 * Handles the form submission.
 *
 * @param e The submit event.
 */
async function submitForm(e: SubmitEvent) {
	e.preventDefault();
	if (!formSubmitFunction) {
		throw new Error("Form submit function is not defined");
	}
	try {
		const body = packageRequest(contactForm);
		createLoadingDiv();
		await formSubmitFunction(body);
		createSuccessDiv();
	} catch (error) {
		createErrorDiv(String(error));
	}
}
